import {Izbor} from "../../../komponente/izbor/Izbor";
import podaci from './podaci.json';

export default class Diverzija extends Izbor {
  constructor() {
    super(podaci);
  }
}



// WEBPACK FOOTER //
// ./src/hronologija/1941/09-09/Diverzija.js